import { render } from "./ArticleBanner.vue?vue&type=template&id=4e5b740c&scoped=true"
import script from "./ArticleBanner.vue?vue&type=script&lang=js"
export * from "./ArticleBanner.vue?vue&type=script&lang=js"

import "./ArticleBanner.vue?vue&type=style&index=0&id=4e5b740c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5b740c"]])

export default __exports__